app.controller("UsersIndexController", ["$scope", "Users", "$uibModal", "$stateParams", "$state", "toastr", "Access",
    function ($scope, Users, $uibModal, $stateParams, $state, toastr, Access) {
        $scope.users = [];
        $scope.roles = [];
        $scope.signature = $stateParams.signature;
        $scope.signatureOptions = [
            { value: '', name: 'ყველა (ხელმოწ.)' },
            { value: 'yes', name: 'ხელმოწერით' },
            { value: 'no', name: 'ხელმოწერ. გარეშე' },
        ];
        $scope.totalItems = 0;
        $scope.itemsPerPage = 20;
        $scope.query = $stateParams.query;
        $scope.rights = [];
        $scope.selectedRights = [];

        function loadRights() {
            return Access.fetchPermissionList('USER').then(function (result) {
                $scope.rights = result;
                $scope.selectedRights = $scope.rights.filter(function (el) {
                    if (Array.isArray($stateParams.right)) {
                        return $stateParams.right.indexOf(el._id) !== -1
                    }
                    return el._id === $stateParams.right;
                });
            });
        }

        loadRights();

        $scope.getRights = function (name) {
            if (name.length < 1) {
                return [];
            }
            var resolvable = $scope.rights.filter(function (el) {
                return el.name.includes(name)
            });
            return Promise.resolve(resolvable);
        };

        $scope.addRightToFilter = function () {
            if ($scope.selectedRights.indexOf($scope.right) > -1) return;
            $scope.selectedRights.push($scope.right);
            $scope.right = null;
        };

        $scope.removeRight = function (r) {
            $scope.selectedRights = $scope.selectedRights.filter(function (el) {
                return el._id !== r._id
            });
            $scope.changePage();
        };

        loadPage($stateParams.page, function () {
            $scope.currentPage = $stateParams.page;
        });

        function loadPage(page, cb) {
            cb = cb || function () {
            };
            Users.list({
                page: page,
                limit: $scope.itemsPerPage,
                query: $stateParams.query,
                right: $stateParams.right,
                signature: $stateParams.signature
            }).then(function (data) {
                $scope.users = data.docs;
                $scope.totalItems = data.total;
                cb()
            });
        }

        $scope.goToPage = function (page) {
            $state.go(".", {
                query: $scope.query,
                right: $scope.selectedRights.length ? $scope.selectedRights.map(function (r) {
                    return r._id;
                }) : undefined,
                signature: $scope.signature,
                page: page,
            });
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        $scope.edit = function (user, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "ManageRolesController",
                templateUrl: _pb + 'sudo/users/manage-roles.html',
                size: "md",
                resolve: {
                    params: {
                        user: user._id,
                        type: 'USER'
                    }
                }
            }).result
                .then(function (result) {
                    loadPage()
                }, function () {
                });
        };

        $scope.changePassword = function (user, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }

            $uibModal.open({
                controller: "ChangePasswordController",
                templateUrl: _pb + 'sudo/users/changePasswordWindow.html',
                size: "md",
                resolve: {
                    user: function () {
                        return user._id
                    }
                }
            }).result
                .then(function (result) {

                }, function () {
                });
        };

        $scope.changeSignature = function (user, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }

            $uibModal.open({
                controller: "SudoSignatureModalController",
                templateUrl: _pb + 'sudo/users/sudo-signature-modal.html',
                size: "md",
                resolve: {
                    params: function () {
                        return { user: user }
                    }
                }
            }).result
                .then(function (result) {
                    loadPage();
                }, function () {
                });
        };

        $scope.add = function () {
            $uibModal.open({
                controller: "AddUserController",
                templateUrl: _pb + 'admin/users/add-user.html',
                size: "md"
            }).result
                .then(function (result) {
                    loadPage()
                }, function () {
                });
        };
    }
]);
